import { useNavigate } from 'react-router-dom'
import { Button, EmptyState } from '@/ui'

export function NotFound() {
  const navigate = useNavigate()
  return (
    <EmptyState
      title="Страница не найдена"
      action={<Button onClick={() => navigate('/orders')}>К заказам</Button>}
    />
  )
}
